// http://codepen.io/OfficialAntarctica/pen/bpxgWZ
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
import './confetti.css';
const rnd = (m, n)=>Math.floor(Math.random() * (n - m + 1)) + m;
const CONFETTI_COUNT = 15;
class Particles extends Component {
    shouldComponentUpdate() {
        return false;
    }
    render() {
        var particles = [];
        for(let i = 0; i <= CONFETTI_COUNT; i++){
            particles.push(/*#__PURE__*/ _jsx("span", {
                className: 'Confetti-particle Confetti-c' + rnd(1, 2),
                style: {
                    width: rnd(6, 8) + 'px',
                    height: rnd(3, 4) + 'px',
                    top: rnd(10, 50) + '%',
                    left: rnd(0, 140) + '%',
                    animationDelay: rnd(0, 30) / 10 + 's'
                }
            }, i));
        }
        return /*#__PURE__*/ _jsx("div", {
            children: particles
        });
    }
}
class Confetti extends Component {
    shouldComponentUpdate(nextProps) {
        return nextProps.label !== this.props.label;
    }
    render() {
        return /*#__PURE__*/ _jsx("div", {
            className: "Confetti",
            children: /*#__PURE__*/ _jsxs("span", {
                className: "Confetti-particles",
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: "Confetti-label",
                        children: this.props.label
                    }),
                    /*#__PURE__*/ _jsx(Particles, {})
                ]
            })
        });
    }
}
export default Confetti;
